var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensorLittleWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bad",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Bad .cls-1 {\n        fill: #ffe200;\n        stroke: rgba(0,0,0,0);\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 -7.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2663",
    "data-name": "Pfad 2663",
    className: "cls-1",
    d: "M12,7.24A10.667,10.667,0,1,1,1.333,17.907,10.679,10.679,0,0,1,12,7.24m0-1.333a12,12,0,1,0,12,12,12,12,0,0,0-12-12",
    transform: "translate(0 1.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2665",
    "data-name": "Pfad 2665",
    className: "cls-1",
    d: "M16.042,18.192a4.589,4.589,0,0,0-3.815,2.041l.735.735a3.558,3.558,0,0,1,6.216.1l.738-.739a4.586,4.586,0,0,0-3.874-2.139",
    transform: "translate(-4.076 -2.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2667",
    "data-name": "Pfad 2667",
    className: "cls-1",
    d: "M19.327,27.05a2.667,2.667,0,1,1-5.333,0c0-1.489,2.667-5.3,2.667-5.3s2.667,3.813,2.667,5.3m-1.48-.878a.693.693,0,1,0,.685.693.688.688,0,0,0-.685-.693",
    transform: "translate(-4.664 -3.475)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorLittleWater);
export default __webpack_public_path__ + "static/media/sensor-little-water.31fd3c80c2689efff055a0a52521c9b4.svg";
export { ForwardRef as ReactComponent };